module.exports = __webpack_public_path__ + "static/media/03.5e42cbdb.jpg";